import { FormattedMessage } from 'react-intl';

import { Season26TutorialDialog } from '@sorare/core/src/components/dialog/Season26TutorialDialog';
import { Season26TutorialStep } from '@sorare/core/src/components/dialog/Season26TutorialStep';
import { glossary } from '@sorare/core/src/lib/glossary';

import { QuickPlayTutorialFooter } from '#src/components/quickPlay/QuickPlayTutorialDialog/QuickPlayTutorialFooter/index.tsx';
import type { QuickPlayTutorialDialogType } from '#src/components/quickPlay/QuickPlayTutorialDialog/types.ts';
import { QuickPlayTutorialHeader } from '#src/components/quickPlay/QuickPlayTutorialHeader/index.tsx';

import { GetRewarded } from './GetRewarded/index.tsx';
import { HitScoreTarget } from './HitScoreTarget/index.tsx';
import { StartStreak } from './StartStreak/index.tsx';
import background from './assets/background.webp';

type Props = {
  open: boolean;
  onContinue: () => void;
  loading: boolean;
  onSelect: (type: QuickPlayTutorialDialogType) => void;
  disableAnimation: boolean;
};
export const IntroducingQuickPlayDialog = ({
  open,
  onContinue,
  loading,
  onSelect,
  disableAnimation,
}: Props) => {
  return (
    <Season26TutorialDialog
      open={open}
      onClose={onContinue}
      color="var(--c-blue-400)"
      textColor="var(--c-black)"
      headerBackgroundUrl={background}
      disableAnimation={disableAnimation}
      hideTextureBackground
      gap={2}
      titleGroup={
        <QuickPlayTutorialHeader
          overline={<FormattedMessage {...glossary.introducing} />}
          title={<FormattedMessage {...glossary.quickPlay} />}
        />
      }
      items={[
        <Season26TutorialStep stepNb={1} key="1" fullHeight={!disableAnimation}>
          <HitScoreTarget />
        </Season26TutorialStep>,
        <Season26TutorialStep stepNb={2} key="2" fullHeight={!disableAnimation}>
          <GetRewarded />
        </Season26TutorialStep>,
        <Season26TutorialStep stepNb={3} key="3" fullHeight={!disableAnimation}>
          <StartStreak />
        </Season26TutorialStep>,
      ]}
      footer={
        <QuickPlayTutorialFooter
          onSelect={onSelect}
          onContinue={onContinue}
          loading={loading}
          selectedType="quickPlay"
        />
      }
    />
  );
};
